import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { FingerPrintService } from 'src/app/services/fingerPrint/fingerprint.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-fingerprintpopup',
    templateUrl: 'fingerprintpopup.component.html',
    styleUrls: ['fingerprintpopup.component.scss'],
    standalone: false
})

export class FingerprintpopupComponent implements OnInit, AfterViewInit {

  @ViewChild('fingerPrintAuthModal', { static: true }) fingerPrintAuthModal: ModalDirective;
  @Input() paymentOrigin = 0;
  @Output() cancelFingerPrint = new EventEmitter<any>();
  @Output() emitSuccess = new EventEmitter<any>();
modalConfig = {
  backdrop: 'static',
  keyboard: false
};
  fingerPrintInit: any;
  isFingerprintAcquired: boolean = false;
  fingerPrintObject: { UserId: number; ImageData: any; Data: any; CbeffId: any; Width: any; Height: any; Resolution: any; Initials: any; Pin: string; };
  isFingerPrintDevice: boolean;
  scanMessage: any;
  fingerprintMessage: any = '';
  isFingerPrintEnabled = environment.isFingerPrintEnabled;
  initials = '';
  pin = '';
  observerCount = 0;
  modType = 0;
  disableSaveButton = false;

  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };

  constructor(public fingerPrintService: FingerPrintService,
    private toaster: ToastrService) { }

  ngOnInit(): void {
    this.fingerPrintService.paymentOrigin = this.paymentOrigin;
  }

  openFingerprintModal() {
    this.fingerPrintAuthModal.show();
    this.fingerPrintService.userId = 0;
    this.fingerPrintService.isFingerPrintUsed = false;
    this.isFingerprintAcquired = false;
    this.fingerPrintService.moduleType = 2;

    this.fingerPrintService.captureEventEmitter.subscribe((obj) => {
      let fingerObj = {
        UserId: 0,
        ImageData: obj.ImageData,
        Data: obj.Data,
        CbeffId: obj.CbeffId,
        Width: obj.width,
        Height: obj.height,
        Resolution: obj.resolution,
        Initials: null,
        Pin: null
      }

      this.fingerPrintObject = fingerObj;
      if (this.fingerPrintService.moduleType == 2 && this.observerCount == 0) {
        this.callCompareFingerEndpoint(fingerObj);
      }
    });
  }

  callCompareFingerEndpoint(fingerObj) {
    this.observerCount++;
    this.fingerPrintService.compareFingerEndpoint(fingerObj).pipe(take(1)).subscribe((response: any) => {
      this.observerCount = 0;
      if (response && response.Success) {
        this.isFingerprintAcquired = true;
        this.fingerPrintService.userId = response.Id;
        this.fingerPrintService.isFingerPrintUsed = true;
        this.initials = '';
        this.pin = '';
        this.fingerPrintAuthModal.hide();
        this.disableSaveButton = false;
        this.emitSuccess.emit(true);
      } else {
        this.disableSaveButton = false;
        this.isFingerprintAcquired = false;
        if (response && response.Message) {
          this.fingerprintMessage = response.Message;
        } else {
          this.fingerprintMessage = 'Initial/PIN invalid';
        }
      }
    }, err => {
      this.observerCount = 0;
      this.disableSaveButton = false;
      this.toaster.error('Failed to Validate Initial/PIN', 'Error', this.toasterConfig);
    });
  }

  ngAfterViewInit(): void {

    //   this.fingerPrintInit.startCapture();
    //   this.getFingerPrintDeviceInfo();
    //   this.captureFingerPrintmessage();
  }

  getFingerPrintDeviceInfo() {
    this.fingerPrintService.checkForDevice.subscribe((resp) => {
      if (resp && resp.length) {
        this.isFingerPrintDevice = true;
      } else {
        this.isFingerPrintDevice = false;
      }
      if (resp.message) {
        this.isFingerPrintDevice = false;
      }
    });
  }

  captureFingerPrintmessage() {
    this.fingerPrintService.captureMessage.subscribe((obj) => {
      if (obj) {
        if (obj.type == 1 && !this.isFingerPrintDevice) {
          this.isFingerPrintDevice = true;
        }
        this.scanMessage = obj.message;
      }
    });
  }

  cancelFingerPrintPopup() {
    this.fingerPrintAuthModal.hide();
    this.cancelFingerPrint.emit(true);
    this.fingerprintMessage = '';
    this.initials = '';
    this.pin = '';
  }

  resetFingerprintOrigin() {
    this.fingerPrintService.paymentOrigin = 0;
    this.fingerPrintService.isFingerPrintUsed = false;
    this.fingerPrintService.userId = 0;
    this.fingerPrintService.moduleType = 1;
  }

  matchPin() {
    this.disableSaveButton = true;
    let fingerObj = {
      UserId: 0,
      ImageData: null,
      Data: null,
      CbeffId: null,
      Width: null,
      Height: null,
      Resolution: null,
      Initials: this.initials,
      Pin: this.pin
    }
    this.callCompareFingerEndpoint(fingerObj);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 47 || charCode > 57 || charCode === 47)) {
      return false;
    }
    return true;
  }

  disableSave() {
    if (this.initials == '' || this.pin == '') {
      return true;
    } else if (this.disableSaveButton) {
      return true;
    } else {
      return false;
    }
  }
}
